module.exports = __webpack_public_path__ + "img/Kroma.51f900b6.png";